/**
 * Anubis prueba social: avisos flotantes con opiniones reales.
 *
 * Los datos los arma snippets/social-proof.liquid (JSON dentro de
 * #anubis-sp): las ventas recientes que manda la app (o, si no hay, las
 * opiniones mas recientes), la nota promedio y hasta dos mensajes de la
 * tienda. Aca no se inventa nada: no hay compras al azar ni contadores de
 * gente mirando.
 *
 * Por visita (sessionStorage) salen como mucho `maximo` avisos y, si el
 * visitante cierra uno, no sale ninguno mas. La cuenta sigue entre
 * paginas, asi que al cambiar de pagina no se repite el primer aviso.
 */

(function () {
  const raiz = document.getElementById('anubis-sp');
  const datos = raiz && raiz.querySelector('[data-sp-config]');
  if (!datos) return;

  let cfg;
  try {
    cfg = JSON.parse(datos.textContent);
  } catch (e) {
    return;
  }

  if (cfg.movil === false && window.matchMedia('(max-width: 749px)').matches) return;

  const CLAVE = 'anubis-sp';
  const leerEstado = () => {
    try {
      return JSON.parse(sessionStorage.getItem(CLAVE)) || {};
    } catch (e) {
      return {};
    }
  };
  const guardarEstado = (estado) => {
    try {
      sessionStorage.setItem(CLAVE, JSON.stringify(estado));
    } catch (e) {}
  };

  const maximo = cfg.maximo || 3;
  const agotado = (estado) => estado.cerrado || (estado.vistos || 0) >= maximo;
  if (agotado(leerEstado())) return;

  // Los textos llegan con el HTML escapado; un textarea los decodifica
  // sin ejecutar nada y despues se pintan como texto.
  const decodificador = document.createElement('textarea');
  const texto = (s) => {
    decodificador.innerHTML = s || '';
    return decodificador.value.trim();
  };
  const enlace = (s) => {
    const url = texto(s);
    return /^(\/|https:\/\/)/.test(url) ? url : '';
  };

  // Ventas recientes (pedidos pagados que manda la app, con gift cards) o, si
  // no hay, opiniones; intercaladas con los extras (nota, mensajes de la tienda).
  const ventas = (cfg.ventas || [])
    .filter((v) => texto(v.nombre) && (v.productos || []).length)
    .map((v) => ({ tipo: 'venta', ...v }));
  const opiniones = ventas.length
    ? ventas
    : (cfg.opiniones || []).filter((o) => texto(o.nombre)).map((o) => ({ tipo: 'opinion', ...o }));
  const extras = [];
  if (cfg.nota && cfg.nota.total > 0) extras.push({ tipo: 'nota', ...cfg.nota });
  (cfg.mensajes || []).forEach((m) => {
    if (texto(m)) extras.push({ tipo: 'tienda', texto: texto(m) });
  });

  const avisos = [];
  for (let i = 0; i < Math.max(opiniones.length, extras.length); i++) {
    if (opiniones[i]) avisos.push(opiniones[i]);
    if (extras[i]) avisos.push(extras[i]);
  }
  if (!avisos.length) return;

  // "2026-10-22" -> "hace 3 días". La fecha no trae hora: se cuentan días.
  function haceCuanto(fecha) {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(fecha || '');
    if (!m) return '';
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);
    const dias = Math.round((hoy - new Date(+m[1], m[2] - 1, +m[3])) / 864e5);
    if (dias <= 0) return 'hoy';
    if (dias === 1) return 'ayer';
    if (dias < 7) return `hace ${dias} días`;
    if (dias < 30) {
      const semanas = Math.floor(dias / 7);
      return semanas === 1 ? 'hace 1 semana' : `hace ${semanas} semanas`;
    }
    if (dias < 365) {
      const meses = Math.floor(dias / 30);
      return meses === 1 ? 'hace 1 mes' : `hace ${meses} meses`;
    }
    return 'hace más de un año';
  }

  function recortar(s, max) {
    if (s.length <= max) return s;
    const espacio = s.lastIndexOf(' ', max);
    const corte = espacio > max * 0.6 ? espacio : max;
    return s.slice(0, corte).replace(/[\s.,;:!¡?¿-]+$/, '') + '…';
  }

  function el(tag, clase, contenido) {
    const nodo = document.createElement(tag);
    if (clase) nodo.className = clase;
    if (contenido != null) nodo.textContent = contenido;
    return nodo;
  }

  function estrellas(n) {
    const caja = el('span', 'anubis-sp-toast__stars');
    caja.setAttribute('role', 'img');
    caja.setAttribute('aria-label', `${n} de 5 estrellas`);
    caja.append('★'.repeat(n), el('span', 'anubis-sp-toast__stars-off', '★'.repeat(5 - n)));
    return caja;
  }

  function armar(aviso) {
    const toast = el('div', `anubis-sp-toast anubis-sp-toast--${aviso.tipo}`);
    const href = aviso.tipo === 'tienda' ? '' : enlace(aviso.url) || enlace(cfg.enlace);
    const principal = el(href ? 'a' : 'div', 'anubis-sp-toast__main');
    if (href) principal.href = href;
    const media = el('span', 'anubis-sp-toast__media');
    media.setAttribute('aria-hidden', 'true');
    const info = el('span', 'anubis-sp-toast__info');

    if (aviso.tipo === 'venta') {
      // «Williams R. compró: DOOM Eternal - It Takes Two». Sin fecha ni
      // comentario; estrellas solo si el pedido tiene una opinion publicada.
      const nombre = texto(aviso.nombre);
      media.classList.add('anubis-sp-toast__media--inicial');
      media.textContent = nombre.charAt(0).toUpperCase();

      const n = Math.min(5, Math.max(0, Math.round(aviso.estrellas) || 0));
      if (n > 0) {
        const arriba = el('span', 'anubis-sp-toast__top');
        arriba.append(estrellas(n));
        info.append(arriba);
      }
      const linea = el('span', 'anubis-sp-toast__line');
      linea.append(el('strong', null, nombre), ' compró:');
      const productos = aviso.productos.map(texto).filter(Boolean);
      const lista = el('span', 'anubis-sp-toast__line');
      lista.append(el('strong', null, productos.slice(0, 2).join(' - ')));
      if (productos.length > 2) lista.append(` y ${productos.length - 2} más`);
      info.append(linea, lista);
      const consolas = (aviso.consolas || []).map(texto).filter(Boolean);
      if (consolas.length) {
        const plataformas = el('span', 'anubis-sp-toast__line');
        plataformas.append(el('span', 'anubis-sp-toast__pill', consolas.join(' · ')));
        info.append(plataformas);
      }
      info.append(el('span', 'anubis-sp-toast__verified', 'Compra verificada'));
    } else if (aviso.tipo === 'opinion') {
      const nombre = texto(aviso.nombre);
      // Caratula del juego o, sin ella (o si no carga), la inicial.
      const inicial = () => {
        media.classList.add('anubis-sp-toast__media--inicial');
        media.textContent = nombre.charAt(0).toUpperCase();
      };
      const imagen = enlace(aviso.imagen);
      if (imagen) {
        const img = el('img');
        img.alt = '';
        img.width = 48;
        img.height = 48;
        img.decoding = 'async';
        img.addEventListener('error', inicial, { once: true });
        img.src = imagen;
        media.append(img);
      } else {
        inicial();
      }

      const arriba = el('span', 'anubis-sp-toast__top');
      const n = Math.min(5, Math.max(0, Math.round(aviso.estrellas) || 0));
      arriba.append(estrellas(n));
      const cuando = haceCuanto(aviso.fecha);
      if (cuando) arriba.append(el('span', null, cuando));

      const linea = el('span', 'anubis-sp-toast__line');
      linea.append(el('strong', null, nombre));
      const juego = texto(aviso.juego);
      if (juego) {
        linea.append(' compró ', el('strong', null, juego));
        if (aviso.mas > 0) linea.append(aviso.mas === 1 ? ' y 1 juego más' : ` y ${aviso.mas} juegos más`);
        const consola = texto(aviso.consola);
        if (consola) linea.append(' ', el('span', 'anubis-sp-toast__pill', consola));
      } else {
        linea.append(' calificó su compra');
      }
      info.append(arriba, linea);

      const comentario = texto(aviso.comentario);
      if (comentario) info.append(el('span', 'anubis-sp-toast__quote', `“${recortar(comentario, 110)}”`));
      info.append(el('span', 'anubis-sp-toast__verified', 'Compra verificada'));
    } else if (aviso.tipo === 'nota') {
      media.classList.add('anubis-sp-toast__media--nota');
      media.textContent = '★';
      const nota = Number(aviso.promedio).toLocaleString('es-CL', {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      });
      const linea = el('span', 'anubis-sp-toast__line');
      linea.append(
        el('strong', null, `${nota} de 5`),
        ` en ${aviso.total} ${aviso.total === 1 ? 'opinión' : 'opiniones'} de clientes`
      );
      info.append(linea, el('span', 'anubis-sp-toast__verified', 'Compras verificadas'));
      if (href) info.append(el('span', 'anubis-sp-toast__link', 'Ver opiniones →'));
    } else {
      media.textContent = '⚡';
      info.append(el('span', 'anubis-sp-toast__line', aviso.texto));
    }

    principal.append(media, info);
    const cerrar = el('button', 'anubis-sp-toast__close', '×');
    cerrar.type = 'button';
    cerrar.setAttribute('aria-label', 'Cerrar y no mostrar más avisos');
    toast.append(principal, cerrar);
    return toast;
  }

  const duracion = (cfg.duracion || 7) * 1000;
  // Entre un aviso y el siguiente queda al menos un respiro sin avisos.
  const intervalo = Math.max((cfg.intervalo || 14) * 1000, duracion + 3000);
  let actual = null;
  let reloj = 0;

  function ocultar(toast) {
    if (!toast) return;
    if (toast === actual) {
      clearTimeout(reloj);
      actual = null;
    }
    toast.classList.remove('is-visible');
    setTimeout(() => toast.remove(), 400);
  }

  function arrancarReloj() {
    clearTimeout(reloj);
    const toast = actual;
    reloj = setTimeout(() => ocultar(toast), duracion);
  }

  // Esperar si la pestaña no se ve, si esta el aviso de cookies (cubre la
  // parte de abajo) o si el visitante esta leyendo el aviso anterior.
  function ocupado() {
    const cookies = document.getElementById('anubis-cookie-banner');
    return (
      document.hidden ||
      (cookies && !cookies.hidden) ||
      (actual && actual.matches(':hover, :focus-within'))
    );
  }

  function mostrar() {
    const estado = leerEstado();
    if (agotado(estado)) return;
    if (ocupado()) {
      setTimeout(mostrar, 4000);
      return;
    }

    const indice = (estado.siguiente || 0) % avisos.length;
    const vistos = (estado.vistos || 0) + 1;
    guardarEstado({ ...estado, vistos, siguiente: indice + 1 });

    ocultar(actual);
    const toast = armar(avisos[indice]);
    actual = toast;
    raiz.append(toast);
    requestAnimationFrame(() => requestAnimationFrame(() => toast.classList.add('is-visible')));
    arrancarReloj();

    // Mientras lo leen (mouse encima o foco dentro) no se cierra solo.
    toast.addEventListener('mouseenter', () => clearTimeout(reloj));
    toast.addEventListener('focusin', () => clearTimeout(reloj));
    toast.addEventListener('mouseleave', () => toast === actual && arrancarReloj());
    toast.addEventListener('focusout', (e) => {
      if (toast === actual && !toast.contains(e.relatedTarget)) arrancarReloj();
    });
    toast.querySelector('.anubis-sp-toast__close').addEventListener('click', () => {
      guardarEstado({ ...leerEstado(), cerrado: true });
      ocultar(toast);
    });

    if (vistos < maximo) setTimeout(mostrar, intervalo);
  }

  setTimeout(mostrar, (cfg.retraso || 8) * 1000);
})();
